import { cn } from "@/lib/utils";

/** @param {{ density?: 'default' | 'compactDesktop' | 'subDesktop' }} props */
export function NavLeafButton({
  leaf,
  collapsed,
  isActive,
  onNavigate,
  className,
  density = "default",
}) {
  const Icon = leaf.icon;
  const iconSize = collapsed ? 24 : density === "subDesktop" ? 16 : 18;
  return (
    <button
      type="button"
      onClick={() => onNavigate(leaf.path)}
      title={collapsed ? leaf.label : undefined}
      aria-label={leaf.label}
      aria-current={isActive ? "page" : undefined}
      className={cn(
        "w-full flex items-center min-h-[44px] rounded-xl transition-all duration-200 ease-in-out group relative cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        density === "compactDesktop" && !collapsed && "md:min-h-9 md:py-1.5 gap-3",
        density === "subDesktop" &&
          !collapsed &&
          "min-h-8 gap-2 rounded-md px-2 py-1.5 text-sm md:min-h-7",
        collapsed
          ? "justify-center w-11 h-11 md:w-11 md:min-h-11 px-0 mx-auto"
          : "w-full gap-2 px-3 py-2.5",
        isActive
          ? "bg-primary/14 text-primary border border-primary/25 font-semibold shadow-xs"
          : "text-muted-foreground hover:bg-muted/60 hover:text-foreground",
        className,
      )}
    >
      <Icon
        size={iconSize}
        className={cn(
          "shrink-0 transition-colors",
          isActive ? "text-primary" : "text-muted-foreground group-hover:text-foreground",
          collapsed && "h-6 w-6",
        )}
        aria-hidden
      />
      {!collapsed && (
        <span className="flex-1 text-left text-sm whitespace-nowrap tracking-tight">
          {leaf.label}
        </span>
      )}
      {!collapsed && leaf.badge !== undefined && leaf.badge > 0 && (
        <span className="shrink-0 bg-primary text-primary-foreground text-overline-size font-bold px-2 py-0.5 rounded-full min-w-[22px] text-center shadow-2xs">
          {leaf.badge > 99 ? "99+" : leaf.badge}
        </span>
      )}
      {collapsed && leaf.badge !== undefined && leaf.badge > 0 && (
        <span className="absolute top-1 right-1 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-overline-size font-bold text-primary-foreground ring-2 ring-background">
          {leaf.badge > 99 ? "99+" : leaf.badge}
        </span>
      )}
    </button>
  );
}
